import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { Router } from '@angular/router';
import { TreeNode } from 'primeng/api';
import { asyncForEach } from 'src/app/helpers/asyncForEach';
import { localStorageToJsonAsync } from 'src/app/helpers/cookieToJson';
import { systemPermissionsNew } from 'src/app/helpers/systemPermissions';
import { addAlert, apiOfflineAsync } from 'src/app/layouts/pages/pages.component';
import { FunctionService } from 'src/app/services/function.service';
import { UsersService } from 'src/app/services/users/users.service';
import { WorkflowService } from 'src/app/services/workflow/workflow.service';
import { getLanguageCookie } from 'src/assets/language';
import { v4 } from 'uuid';
import { parse, stringify } from "circular-json";

@Component({
  selector: 'app-workflow',
  templateUrl: './workflow.component.html',
  styleUrls: ['./workflow.component.scss']
})
export class WorkflowComponent {
  @ViewChild('menu') menu!: MatMenu;
  @ViewChild('submenu') submenu!: MatMenu;
  @ViewChild('addTrigger') addTrigger!: MatMenuTrigger;

  filterArray: any = []
  filterCursor: number = 0
  isSearch: boolean = false
  text: string = '';
  isShowImport: boolean = false;
  isChangeTree: boolean = false;
  files!: any[];
  filesOld!: any[]
  selectedFile: any;
  openTree: boolean = false;
  noData: boolean = false;
  isEdited = false;
  isLoading: boolean = false;
  properties: any = {}
  formData: FormData = new FormData()
  selectedNode: any = null;
  expandedKeys: { [key: string]: boolean } = {};
  isLoadingExport: boolean = false;
  isChangeTreeModalExit: boolean = false;
  workflow: any = {}
  isShowCreate: boolean = false;
  usersArray: any[] = []
  parameters: any = { node: {} };
  isShowDelete: boolean = false;

  isShowChooseReference: boolean = false
  referenceTreeShared: boolean = false;

  selectedCorporationWorkflow: any = {
    name: '',
    uuid: ''
  }

  menuArray: Array<{
    name: string;
    icon: string;
    action?: (node: any, event: Event | MouseEvent) => void;
    permission?: string;
    condition: (node?: any) => boolean;
    tooltip: string;
    submenu?: Array<{
      name: string;
      action: () => void;
    }>;
    isInfo?: boolean;
  }> = [
      {
        name: 'Adicionar',
        icon: 'fa-solid fa-plus',
        action: (node, event: Event) => this.showModalCreate(node, event as MouseEvent),
        permission: 'create_process',
        condition: (node) => this.getSystemPermission('workflow', 'create'),
        tooltip: 'businessSolution/top/info/add'
      },
      {
        name: 'Indisponível',
        icon: 'fas fa-ban',
        action: (node, event: Event) => this.chooseAvailability(node, event as MouseEvent),
        permission: 'choose_availability',
        condition: (node) => this.getSystemPermission('workflow', 'choose_availability'),
        tooltip: 'profiles/permissions/workflow/choose_availability'
      },
      {
        name: 'Excluir',
        icon: 'fas fa-trash',
        action: (node, event: Event) => this.showDeleteItemModal(node, event as MouseEvent),
        permission: 'delete_process',
        condition: (node) => this.getSystemPermission('workflow', 'delete') && 
          (node?.children?.length == 0),
        tooltip: 'businessSolution/top/info/delete_process'
      },
    ];

  constructor(private cdr: ChangeDetectorRef,
    public sharedData: FunctionService,
    private router: Router,
    private usersService: UsersService,
    private workflowService: WorkflowService,
  ) {}

  async ngOnInit() {
    this.properties = await localStorageToJsonAsync()
    await this.getWorkflow()
    await this.getUsers()
  }

  getLanguages(file: string) {
    return getLanguageCookie(file, localStorage.getItem('language'))
  }

  getSystemPermission(screen: string, action?: string) {
    return systemPermissionsNew(screen, action)
  }

  getAncestors(currentNode: any, rootNodes: any[]): any[] {
    if (!Array.isArray(rootNodes) || !rootNodes.length) return [];

    const targetNodeUuid = currentNode?.uuid ?? null;
    const targetEmail = currentNode?.email ?? null;

    if (!targetNodeUuid && !targetEmail) return [];

    let found = false;
    let ancestors: any[] = [];

    function walk(node: any, parents: any[] = []) {
      if (found) return;
      const children = node?.children ?? [];
      if (!children.length) return;

      for (const child of children) {
        if (found) return;

        const isMatch = targetNodeUuid
          ? child?.uuid === targetNodeUuid
          : child?.email === targetEmail;

        if (isMatch) {
          ancestors = parents.concat(node);
          found = true;
          return;
        }

        walk(child, parents.concat(node));
      }
    }

    for (const root of rootNodes) {
      if (found) break;
      walk(root, []);
    }

    return ancestors;
  }

  showModalCreate(node: any = {}, event?: Event) {
    const fullUsers = Array.isArray(this.usersArray) ? this.usersArray : [];
    let filteredUsers = [...fullUsers];
    this.parameters.node.access_users_array = this.parameters.node.access_users_array ?? []
    if (node?.uuid) {
      this.parameters.node.uuid = node.uuid;
    }

    const nodeEmail = node?.email ?? null;

    if (nodeEmail) {
      const treeRoots = this.files ?? [];

      const ancestors = this.getAncestors(
        node?.uuid ? { uuid: node.uuid } : { email: nodeEmail },
        treeRoots
      );

      const toRemoveUuids = new Set<string>(
        [
          ...ancestors.map(a => a?.email).filter(Boolean),
          nodeEmail
        ]
      );

      filteredUsers = fullUsers.filter(
        user => user?.email && !toRemoveUuids.has(user.email)
      );
    } else {
      filteredUsers = fullUsers;
    }

    let childrenArray: any[] = node?.uuid ? node.children : this.files
    childrenArray = childrenArray.map((item: any) => { return item.email })
    filteredUsers.forEach((item: any) => {
      if (childrenArray.includes(item.email)) {
        this.parameters.node.access_users_array.push(item.email)
      }
    })

    filteredUsers = filteredUsers.map((item: any) => {
      return {
        name: item.name,
        email: item.email
      }
    })

    this.parameters.usersArray = filteredUsers;
    this.isShowCreate = true;
  }

  closeShowCreate() {
    this.parameters.node = { access_users_array: [] }
    this.isShowCreate = false;
  }

  chooseAvailability(node: any = {}, event?: Event) {
    if (!node) {
      return;
    }
  
    if (node.is_available === undefined) {
      node.is_available = true;
    }
    const newValue = !node.is_available;
  
    const updateAvailability = (treeNodes: any[]) => {
      for (const n of treeNodes) {
        if (n.email === node.email) {
          n.is_available = newValue;
        }
        if (n.children && n.children.length > 0) {
          updateAvailability(n.children);
        }
      }
    };
  
    updateAvailability(this.files);
    this.isEdited = true;
  }
  
  async getWorkflow() {
    this.noData = false;
    this.isLoading = true;
    
    try {
      const response: any = await this.workflowService.getWorkflow({
        ...this.parameters,
        corporation_uuid: this.selectedCorporationWorkflow.uuid
      }).toPromise();
  
      this.isLoading = false;
  
      if (response && response.data) {
        this.workflow = parse(response.data);
        this.isShowImport = false;
  
        if (this.selectedCorporationWorkflow.uuid) {
          delete this.selectedCorporationWorkflow;
          delete this.workflow.uuid;
        }
  
        this.referenceTreeShared = this.workflow.reference_tree_shared ?? false;
  
        // 🔹 Garante que seja array
        let workflowJson = this.workflow.json;
        if (typeof workflowJson === 'string') {
          try {
            workflowJson = parse(workflowJson); // ou JSON.parse
          } catch {
            workflowJson = [];
          }
        }
        if (!Array.isArray(workflowJson)) {
          workflowJson = [];
        }
  
        this.files = workflowJson;
        this.filesOld = workflowJson;
  
        this.noData = this.files.length === 0;
        await this.flipTree();
      } else {
        throw new Error('Erro ao consultar workflow!\nConsulte o administrador do sistema!');
      }
    } catch (error: any) {
      await apiOfflineAsync(error);
    }
  }

  async getUsers(status: any = null) {
    try {
      const response: any = await this.usersService.getUsers(status, { owner: true }).toPromise();
      if (response && response.data) {
        this.usersArray = response.data
      } else {
        throw new Error('Erro ao consultar array de status!\nConsulte o administrador do sistema!');
      }
    } catch (error: any) {
      await apiOfflineAsync(error)
    }
  }

  setArrayAccessUsers(event: any) {
    const children: any = []
    this.parameters.usersArray.forEach((item: any) => {
      if (event.node.access_users_array.includes(item?.email)) {
        children.push({
          uuid: v4(),
          label: item.name,
          email: item.email,
          children: []
        })
      }
    });

    if (event.node.uuid) {
      const node = this.findNodeByUUID(this.files, event.node.uuid);
      console.log(node.children)
      if (node) {
        node.children = children.map((child: any) => {
          const existingNode = node?.children?.find((file: any) => file.email === child.email);
          if (existingNode) {
            return { ...child, children: existingNode.children, is_available: existingNode.is_available};
          }

          return child;
        });
      }
    } else {
      this.files = children.map((child: any) => {
        const existingNode = this.files?.find((file: any) => file.email === child.email);

        if (existingNode) {
          return { ...child, children: existingNode.children, is_available: existingNode.is_available};
        }

        return child;
      });
    }

    this.isEdited = true;
    this.verifyNoData()
  }

  async flipTree() {
    this.openTree = !this.openTree;
    if (this.openTree) {
      return this.expandAll()
    }
    return this.collapseAll()
  }

  async collapseAll() {
    if (!this.files || !this.files?.length) {
      return
    }
    this.files?.forEach((node) => {
      this.expandRecursive(node, false);
    });
  }

  searchNodes(): void {
    this.filterCursor = 0;
    this.isSearch = true;
    this.filterArray = this.filterNodes(this.files, this.text);
    this.next();
  }

  next() {
    if (this.filterCursor < this.filterArray?.length) {
      this.filterCursor++;
      this.scrollToNode(this.filterArray[this.filterCursor - 1]);
    }
  }

  previous() {
    if (this.filterCursor > 1) {
      this.filterCursor--;
      this.scrollToNode(this.filterArray[this.filterCursor - 1]);
    }
  }

  eventStopPropagation(event: Event) {
    event.stopPropagation()
  }

  onMenuOpen(node: any) {
    this.selectedNode = node;
    // this.verifyAddNewLevel(1, node);
  }

  scrollToNode(uuid: string) {
    const node = this.findNodeByUUID(this.files, uuid);

    if (node) {
      this.selectedFile = node;
      this.expandParentNodes(node);

      // Adiciona um pequeno delay para garantir que a árvore foi atualizada
      setTimeout(() => {
        const element = document.getElementById(uuid);

        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          // Tenta expandir todos os nós para encontrar o elemento
          this.expandAll();
          setTimeout(() => {
            const elementAfterExpand = document.getElementById(uuid);
            if (elementAfterExpand) {
              elementAfterExpand.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          }, 100);
        }
      }, 100);
    }
  }

  async expandAll() {
    this.files?.forEach((node) => {
      this.expandRecursive(node, true);
    });
  }

  expandRecursive(node: any, isExpand: boolean) {
    this.openTree = isExpand
    node.expanded = isExpand;
    if (node.children) {
      node.children.forEach((childNode: any) => {
        this.expandRecursive(childNode, isExpand);
      });
    }
  }

  expandParentNodes(node: any) {
    let parentNode = node.parent;

    while (parentNode) {
      parentNode.expanded = true;
      parentNode = parentNode.parent;
    }
  }

  findNodeByUUID(nodes: any[], uuid: string): any {
    for (let node of nodes) {

      if (node.uuid === uuid) {
        return node;
      }

      if (node.children && node.children?.length > 0) {
        const found = this.findNodeByUUID(node.children, uuid);
        if (found) return found;
      }
    }

    return null;
  }

  filterNodes(nodes: any[], query: string): string[] {
    const result: string[] = [];
    const searchText = query.toLowerCase();

    const searchNode = (node: any) => {
      if (node.label && node.label.toLowerCase().includes(searchText)) {
        result.push(node.uuid);
      }

      if (node.children) {
        node.children.forEach(searchNode);
      }
    };

    nodes.forEach(searchNode);

    return result;
  }

  verifyNoData() {
    if (this.files?.length > 0) {
      this.noData = false;
      return
    }
    this.noData = true;
  }

  private filterNode(node: TreeNode, query: string, includeParents: boolean = false): boolean {
    if (!node.label) {
      return false
    }
    const labelMatches = node.label.toLowerCase().includes(query.toLowerCase());

    if (labelMatches) {
      return true;
    }

    if (node.children) {
      const anyChildMatches = node.children.some((child) => this.filterNode(child, query, true));

      if (anyChildMatches) {
        return true;
      }
    }

    return false;
  }

  clearFilter() {
    this.isSearch = false;
    this.filterArray = [];
    this.text = ''
  }

  async toggleUpload() {
    this.isShowImport = !this.isShowImport;
    this.text = ''

    if (!this.isShowImport && this.filesOld !== this.files) {
      this.files = this.filesOld
    }
  }

  async updateFiles(event?: any, ngOnInit?: any) {
    let flagIsImport = false;

    if (!ngOnInit) {
      this.isEdited = true;
      this.sharedData.isChangeTree = true
    }

    if (event) {
      if (event.files) {
        this.files = event.files;
        this.filesOld = event.filesOld ?? event.files;
        if (!event.item) {
          flagIsImport = true
        }
      }
      // if (event.isShow) {
      //   this.isShow = event.isShow
      // }
    }

    this.verifyNoData()

    this.noData = this.files?.length == 0

    if (event?.item) {
      this.selectedFile = event.item

      this.selectedFile.fte = this.selectedFile.fte_one
      this.selectedFile.fte_cost = this.selectedFile.fte_cost_one
    }
  }

  formatDate(date: Date): string {
    const day = ('0' + date.getDate()).slice(-2);
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear();
    const hours = ('0' + date.getHours()).slice(-2);
    const minutes = ('0' + date.getMinutes()).slice(-2);
    const seconds = ('0' + date.getSeconds()).slice(-2);

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  }
  

  async saveTree(version: any = null, uuid: any = null) {
    const updateAllCodes = (nodes: any[], parentCode: string = '') => {
      nodes.sort((a, b) => a.label.localeCompare(b.label, 'pt-BR', { numeric: true }));
      nodes.forEach((node, idx) => {
        const nextSuffix = ((idx + 1) * 5).toString().padStart(2, '0');
        node.data = parentCode ? `${parentCode}.${nextSuffix}` : nextSuffix;
        if (node.children && node.children.length > 0) {
          updateAllCodes(node.children, node.data);
        }
      });
    };

    updateAllCodes(this.files);

    const Error = await this.validateAllEntitys(this.files)
    if (Error == 'SameNameElement') {
      addAlert('orange', this.getLanguages('errors/businessTree/SameNameElement'))
      return  
    }else if (Error == 'SameNameElementAncestor') {
      addAlert('orange', this.getLanguages('errors/businessTree/SameNameElementAncestor'))
      return  
    }

    if (Array.isArray(this.files)) {
      this.files.forEach(async item => await this.removeParentReferences(item));
    }

    this.formData = new FormData()
    this.formData.append('json', stringify(this.files))

    this.isLoading = true;
    // this.isShow = false;
    // this.isShowEdit = false;
    this.clearFilter()
    delete this.selectedFile

    try {
      const response: any = await this.workflowService.setWorkflowTree(this.formData, uuid)
      if ([201, 202].includes(response.status)) {
        addAlert('success', response.message)

        await this.getWorkflow()
      } else{
        addAlert('danger', response.message)
      }
    } catch (error: any) {
      await apiOfflineAsync(error)
    } finally {
      this.isEdited = false;
      this.isLoading = false;
    }
  }

  handleMenuItemClick(item: any, event: Event) {
    if (item.action) {
      item.action(this.selectedNode, event);
    }
    if (this.menu) {
      this.menu.closed.emit();
    }
  }

  async validateAllEntitys(rootNodes: any[] = this.files): Promise<string> {  
    const ERROR_FLAG = 'SameNameElement';
    const errorNodes = new Set<any>();
  
    const getEmail = (n: any) => (n?.email ?? '').trim();
  
    // 🔹 Marca duplicados entre irmãos
    const markSiblingDupes = (nodes: any[] | undefined, ctx: string) => {
      if (!Array.isArray(nodes) || nodes.length === 0) return;
  
      const byEmail = new Map<string, any[]>();
      for (const n of nodes) {
        const email = getEmail(n);
        if (!email) continue;
        const arr = byEmail.get(email) ?? [];
        arr.push(n);
        byEmail.set(email, arr);
      }
  
      for (const [email, group] of byEmail) {
        if (group.length > 1) {
          for (const dup of group) errorNodes.add(dup);
        }
      }
    };
  
    // 🔹 DFS com checagem de ancestrais
    const dfs = (node: any, ancestors: any[], path: string) => {
      const email = getEmail(node);
      const id = node?.uuid ?? '(sem-uuid)';
  
      // 1) Checagem contra ancestrais
      if (email) {
        const matches = ancestors.filter(a => getEmail(a) === email);
        if (matches.length > 0) {
          errorNodes.add(node);
          for (const anc of matches) errorNodes.add(anc);
        }
      }
  
      // 2) Checagem de irmãos (os filhos do nó atual)
      const children = Array.isArray(node?.children) ? node.children : [];
      markSiblingDupes(children, `${path} > ${email || id}`);
  
      // 3) Descer recursivamente
      for (const child of children) {
        dfs(child, [...ancestors, node], `${path} > ${email || id}`);
      }
    };
  
    // 🔹 1ª checagem: duplicados na raiz
    markSiblingDupes(rootNodes, 'root');
  
    // 🔹 DFS em cada raiz
    for (const root of Array.isArray(rootNodes) ? rootNodes : []) {
      dfs(root, [], 'root');
    }
  
    // 🔹 Limpa erros antigos
    const clearErrors = (nodes: any[]) => {
      if (!Array.isArray(nodes)) return;
      for (const n of nodes) {
        delete n.error;
        if (Array.isArray(n?.children) && n.children.length) clearErrors(n.children);
      }
    };
  
    // 🔹 Aplica os novos erros
    const applyErrors = (nodes: any[]) => {
      if (!Array.isArray(nodes)) return;
      for (const n of nodes) {
        if (errorNodes.has(n)) {
          n.error = ERROR_FLAG;
        }
        if (Array.isArray(n?.children) && n.children.length) applyErrors(n.children);
      }
    };
  
    clearErrors(rootNodes);
    applyErrors(rootNodes);
  
    const hasError = errorNodes.size > 0;  
    if (hasError && this.cdr?.detectChanges) this.cdr.detectChanges();
    return hasError ? ERROR_FLAG : '';
  }

  private updateChildrenData(node: any) {
    if (node.children) {
      const parentData = node.data;
      const step = 5;

      node.children.forEach((child: any, index: number) => {
        const childNumber = (index + 1) * step;
        const formattedNumber = childNumber.toString().padStart(2, '0');
        child.data = `${parentData}.${formattedNumber}`;

        if (child.children && child.children?.length > 0) {
          this.updateChildrenData(child);
        }
      });
    }
  }

  async toggleChangeTree() {
    this.isChangeTree = false
    this.sharedData.isShowModalChangeTree = false
    this.sharedData.isChangeTree = false
    if (!this.sharedData.isShowModalChangeTree && this.sharedData.route != '') {
      await this.router.navigate([this.sharedData.route]);
      localStorage.removeItem('flagIndicator')
      this.sharedData.route = ''
    }
  }

  async removeParentReferences(node: any) {
    if (node && typeof node === 'object') {
      delete node.parent;
      if (Array.isArray(node.children)) {
        node.children.forEach(async (child: any) => await this.removeParentReferences(child));
      }
    }
  }

  isFirstColumn(node: any): boolean {
    if (node.master == 'ROOT' || !node.master) {
      return true
    }
    return false
  }

  hasError(uuid: string): boolean {
    if (!this.sharedData.arrayDuplicateName || this.sharedData.arrayDuplicateName?.length == 0) {
      return false
    }

    return this.sharedData.arrayDuplicateName.includes(uuid)
  }

  onNodeExpand(event: any) {
    if (!event.node.parent) {
      this.files?.forEach((node: any) => {
        if (node.uuid != event.node.uuid) {
          node.expanded = false;
          if (node.children) {
            node.children.forEach((child: any) => {
              child.expanded = false;
            });
          }
        }
      });
    }

    event.node.expanded = true;
    this.cdr.detectChanges();
  }

  async showDeleteItemModal(node: any = {}, event?: Event) {
    if(event){
      event.stopPropagation();
    }

    this.parameters.item = { ...node }
    this.parameters = { ...this.parameters }
    this.parameters.files = this.files
    this.parameters.filesOld = this.files

    this.isShowDelete = node?.uuid !== undefined;
  }

  async getTreeXls(type: string = '') {
    this.isLoading = true;
    try {
      const response: Blob = await this.workflowService.getTreeXls({
        environment: this.properties.environment,
        corporation: this.properties.corporation,
        json: type == 'json',
        xls: type == 'xls'
      });

      await this.workflowService.downloadJsonXls(response, `${this.properties?.corporation?.slug}-workflow`, type)
      addAlert('success', this.getLanguages('businessSolution/top/info/export/success'))

    } catch (error: any) {
      await apiOfflineAsync(error)
    }
    this.isLoading = false;
  }
  async toggleUploadChooseReference(event?: Event) {
    this.isShowChooseReference = !this.isShowChooseReference;

    if(!this.isShowChooseReference && event != undefined){
      try {
        const response: any = await this.workflowService.setWorkflowReference({
          environment: this.properties.environment.uuid,
          corporation: this.properties.corporation.uuid,
          reference_uuid: event
        });
        
        if (response && response.status === 201) {
          addAlert('success', response.message);
          await this.getWorkflow();
        }
      } catch (error) {
        addAlert('danger', 'Erro ao atualizar referência de workflow');
      }
    }
  }

  async choseItemSelect(type: string, value: any) {
    switch (type) {
      case 'corporationWorkflow':
        this.selectedCorporationWorkflow = value;
        this.isEdited = true
        await this.getWorkflow()
        break;
    }
  }
}
